import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { UserLogged } from '../../models/data/userLogged.model';
import { UserToLogin } from '../../models/data/userToLogin.model';
import { Globals } from '../../globals/globals';
import { MarketingGrades } from '../../models/data/marketingGrades.model';
import { NormGrades } from '../../models/data/normGrades.model';
import { HeaderParametersValues } from '../../models/data/headerParametersValues.model';
import { EnquiryByEnquiryNo } from '../../models/data/enquiryByEnquiryNo.model';
import { ItemsByEnquiryNo } from '../../models/data/itemsByEnquiryNo.model';
import { ItemParametersValues } from '../../models/data/itemParametersValues.model';
import { ExtraCostsReasons } from '../../models/data/extraCostsReasons.model';
import { Itdcrs, PastItrs } from '../../models/data/pastItrs.model';
import { ItdcrCreationInfo } from '../../models/data/itdcrCreationInfo.model';
import { ExcelTemplateForItdcr } from '../../models/data/excelTemplateForItdcr.model';
import { ItdcrOffices } from '../../models/data/itdcrOffices.model';
import { ItdcrDetailsVersions } from '../../models/data/itdcrDetailsVersions.model';
import { ItdcrDetailsByVersion } from '../../models/data/itdcrDetailsByVersion.model';
import { EnquiryClosureStatusesAndLostReasons } from '../../models/data/enquiryClosureStatusesAndLostReasons.model';
import { FileUrlByKey } from '../../models/data/fileUrlByKey.model';
import { HistoryByEnquiry, HistoryRecords } from '../../models/data/historyByEnquiry.model';
import { CreateEnquiry } from '../../models/data/createEnquiry.model';
import { NpsAndSchedules } from '../../models/data/npsAndSchedules.model';
import { RawMaterialGrades, RawMaterialGradesForEnquiry } from '../../models/data/rawMaterialGrades.model';
import { AttachmentToUpdate, CustomerSpecialRequirement, Enquiry, EnquiryAttachment, EnquiryHeader, ItemsWithPriceOrMarginChangesResponse, OrderExtraCost } from '../../models/data/enquiry.model';
import { EditEnquiry } from '../../models/data/editEnquiry.model';
import { CloseEnquiryData } from 'src/app/internal/enquiry-book/close-enquiry/close-enquiry.component';
import { UtilsService } from '../utils/utils.service';
import { withAssetVersion } from '../../utils/asset-version';
import { ItemToUpdate } from '../../models/data/itemToUpdate.model';
import { DownloadGridColumn, ItemsFromXlsx } from '../../models/data/itemsFromXlsx.model';
import { LimitationsForNormGrades } from '../../models/data/limitationsForNormGrades.model';
import { CalculateItemWeightParamters } from '../../models/data/calculateItemWeightParameters.model';
import { Users, UserToSave } from '../../models/data/users.model';
import { Groups, GroupToSave } from '../../models/data/groups.model';
import { AuthorizationInfo } from '../../models/data/authInfo.model';
import { AdUsers } from '../../models/data/adUsers.model';
import { FeasibilityDetail } from '../../components/modal-feasibility-options/modal-feasibility-options.component';
import { QuotationConfigurationAndPdf, QuotationData, QuotationDataAndConfiguration } from '../../models/data/quotationData';
import { CostingToolFilterValue } from '../../models/data/costingToolFilterValue.model';
import { CostingToolFilterValueByItem } from '../../models/data/costingToolFilterValueByItem.model';
import { ExtraCostParametersValues, ItemExtraCosts, UpdateItemsPriceAndDelivery } from '../../models/data/extraCostParametersValues.model';
import { DownloadMasterDataResponse, MasterDataVersion, UploadMasterDataResponse } from '../../models/data/masterDataVersion.model';
import { ItemsPricesFromXlsx } from '../../models/data/itemsPricesFromXlsx.model.';
import { TechnicalDescriptionTemplates } from '../../models/data/technicalDescriptionTemplates.model';
import { ItemsCount, ItemsFromAI, ItemsFromAIFilePayload } from '../../models/data/itemsFromIA.model';
import { ItemParametersLengthValues } from '../../models/data/itemParametersLengthValues.model';
import { ImportFileTypesResponse } from '../../models/data/importFileTypes.model';
import { SimiliarEnquiries } from '../../models/data/similiarEnquiries.model';
import { Materials } from '../../models/data/materials.model';
import { ItemAttributesByMaterialCode } from '../../models/data/itemAttributesByMaterialCode.model';
import { CheckEnquiryTotalMargin } from '../../models/data/checkEnquiryTotalMargin.model';
import { FreezeEnquiry } from '../../models/data/freezeEnquiry.model';
import { CalculateMarginsAndPricesResponse } from '../../models/data/calculateMarginsAndPricesResponse.model';
import { CalculateMarginsAndPricesPayload } from '../../models/data/calculateMarginsAndPricesPayload.model';
import { GetItdcrOffices } from '../../models/data/getItdcrOffices';
import { ItcdrAttachments } from '../../models/data/itcdrAttachments';
import { CreateItdcrRequest, CreateItdcrResponse } from '../../models/data/createItdcrRequest.model';
import { SendItdcrRequest } from '../../models/data/sendItdcrRequest.model';
import { ItdcrVisualOverwiev } from '../../models/data/itdcrVisualOverwiev.model';
import { GetItdcrMillsResponse } from '../../models/data/itdcrMill.model';
import { EnquiryTotalPriceAndMargin } from '../../models/data/enquiryTotalPriceAndMargin.model';
import { EnquiryTotalPriceAndMarginPayload } from '../../models/data/enquiryTotalPriceAndMarginPayload.model';
import { CostingToolRecordsResponse } from '../../models/data/costingToolRecords.model';

@Injectable({
  providedIn: 'root'
})
export class BackendService {


  codec = new HttpUrlEncodingCodec;
  constructor(private httpClient: HttpClient, private globals: Globals, private utilsService: UtilsService) {
    if (!this.globals || !this.globals.apiUrl || this.globals.apiUrl == '') {
      //this.utilsService.getApiUrl();
      if (localStorage.getItem('apiUrl') != undefined) {
        this.globals.apiUrl = localStorage.getItem('apiUrl')!;
      } else {
        this.utilsService.getApiUrl();
      }
    }
  }

  /**
  * LoginUser
  * @param username 
  * @param pwd 
  * @returns 
  */
  loginUser(userToLogin: UserToLogin): Observable<UserLogged> {
    if (this.globals.isMock)
      return this.httpClient.get<UserLogged>(withAssetVersion('assets/mock/user.json'));
    else
      return this.httpClient.post<UserLogged>(this.globals.apiUrl + "login", userToLogin);
  }

  /**
   * LOGOUT USER
   * @returns 
   */
  logoutUser(): Observable<any> {
    if (this.globals.isMock)
      return of('ok');
    else
      return this.httpClient.post<UserLogged>(this.globals.apiUrl + "logout", null);
  }

  /**
   * UPDATE USER CONFIGURATION
   * @param userConfiguration 
   * @param language 
   */
  updateUserConfiguration(configuration: string, language: string, dateFormat: string): Observable<any> {
    let _params: any = {
      "configuration": configuration,
      "language": this.codec.encodeValue(language),
      "dateFormat": dateFormat
    }
    return this.httpClient.patch<any>(this.globals.apiUrl + "UpdateUserConfiguration", _params);
  }

  /**
   * CREATE ENQUIRY
   * @param enquiry 
   * @returns 
   */
  createEnquiry(enquiry: CreateEnquiry): Observable<any> {
    // MQF-1073: pricing - set alloy surcharge to true
    enquiry.alloySurcharge = true;
    return this.httpClient.post<any>(this.globals.apiUrl + "CreateEnquiry", enquiry);
  }

  /**
   * EDIT ENQUIRY
   * @param enquiry 
   * @returns 
   */
  editEnquiry(enquiry: EditEnquiry, enquiryNo: string): Observable<any> {

    // MQF-1073: pricing - set alloy surcharge to true
    enquiry.alloySurcharge = true;

    return this.httpClient.put<any>(this.globals.apiUrl + "EditEnquiry?enquiryNo=" + enquiryNo, enquiry);
  }

  /**
   * EDIT AND CREATE VERSION IF NECESSARY
   * @param enquiryNo 
   * @returns 
   */
  editAndCreateVersionIfNecessary(enquiryNo: string, keepItdcrResults?: boolean): Observable<Enquiry> {
    const payload = keepItdcrResults ? { keepItdcrResults: true } : {};
    return this.httpClient.post<Enquiry>(this.globals.apiUrl + "EditAndCreateVersionIfNecessary?enquiryNo=" + enquiryNo, payload);
  }

  /**
   * GET ITEMS WITH PRICE OR MARGIN CHANGES
   * @param enquiryNo
   * @returns
   */
  getEnquiryPriceOrMarginChanges(enquiryNo: string): Observable<ItemsWithPriceOrMarginChangesResponse> {
    if (this.globals.isMock) {
      return of({ items: [] });
    }
    return this.httpClient.get<ItemsWithPriceOrMarginChangesResponse>(this.globals.apiUrl + "GetItemsWithPriceOrMarginChanges?enquiryNo=" + enquiryNo);
  }

  /**
   * GetNormGrades
   * @returns 
  */
  getNormGrades(applicableNorms: string[]): Observable<NormGrades> {
    let _obj: string = "";
    for (var x = 0; x < applicableNorms.length; x++) {
      _obj = _obj + (x > 0 ? "&applicableNorms=" + applicableNorms[x] : "?applicableNorms=" + applicableNorms[x]);
    }
    return this.httpClient.get<NormGrades>(this.globals.apiUrl + "GetNormGrades" + _obj);
  }

  /**
   * GetMarketingGrades
   * @returns 
  */
  getMarketingGrades(normGrades: string[]): Observable<MarketingGrades> {
    let _obj: string = "";
    for (var x = 0; x < normGrades.length; x++) {
      _obj = _obj + (x > 0 ? "&normGrades=" + normGrades[x] : "?normGrades=" + normGrades[x]);
    }
    return this.httpClient.get<MarketingGrades>(this.globals.apiUrl + "GetMarketingGrades" + _obj);
  }

  /**
   * GET RAW MATERIAL GRADES
   * @param marketingGrades 
   * @returns 
   */
  getRawMaterialGrades(normGradeIds: number[]): Observable<RawMaterialGrades> {
    if (normGradeIds && normGradeIds.length) {
      let _param: string = "";
      for (var x = 0; x < normGradeIds.length; x++) {
        _param += 'normGradesId=' + normGradeIds[x] + ((x < normGradeIds.length - 1) ? "&" : '');
      }
      return this.httpClient.get<RawMaterialGrades>(this.globals.apiUrl + "GetRawMaterialGrades?" + _param);
    } else {
      return this.httpClient.get<RawMaterialGrades>(this.globals.apiUrl + "GetRawMaterialGrades");
    }
  }

  /**
   * GET RAW MATERIAL GRADE FROM NORM GRADES AND LIMITATIONS
   * @param normGradesId 
   * @param gradeCustomerAnalysisLimitation 
   * @param gradeCustomerOtherLimitation 
   * @returns 
   */
  getRawMaterialGradesFromNormGradesAndLimitations(normGradeIds: number[], gradeCustomerAnalysisLimitation: string | null, gradeCustomerOtherLimitation: string | null): Observable<RawMaterialGrades> {
    let _param: string = "";
    for (var x = 0; x < normGradeIds.length; x++) {
      _param += 'normGradesId=' + normGradeIds[x] + ((x < normGradeIds.length - 1) ? "&" : '');
    }

    if (gradeCustomerAnalysisLimitation == null || gradeCustomerOtherLimitation == null) {
      return this.httpClient.get<RawMaterialGrades>(this.globals.apiUrl + "GetRawMaterialGradesFromNormGradesAndLimitations?" + _param);
    }
    else {
      return this.httpClient.get<RawMaterialGrades>(this.globals.apiUrl + "GetRawMaterialGradesFromNormGradesAndLimitations?" + _param + "&gradeCustomerAnalysisLimitation=" +
        gradeCustomerAnalysisLimitation + "&gradeCustomerOtherLimitation=" + gradeCustomerOtherLimitation);
    }
  }

  /**
   * GET RAW MATERIAL GRADE FROM NORM GRADES AND LIMITATIONS ASYNC VERSION
   * @param normGradesId 
   * @param gradeCustomerAnalysisLimitation 
   * @param gradeCustomerOtherLimitation 
   * @returns 
   */
  async getRawMaterialGradesFromNormGradesAndLimitationsAsync(normGradeIds: number[], gradeCustomerAnalysisLimitation: string | null, gradeCustomerOtherLimitation: string | null) {
    let _param: string = "";
    for (var x = 0; x < normGradeIds.length; x++) {
      _param += 'normGradesId=' + normGradeIds[x] + ((x < normGradeIds.length - 1) ? "&" : '');
    }
    return this.httpClient.get<RawMaterialGrades>(this.globals.apiUrl + "GetRawMaterialGradesFromNormGradesAndLimitations?" + _param + "&gradeCustomerAnalysisLimitation=" +
      gradeCustomerAnalysisLimitation + "&gradeCustomerOtherLimitation=" + gradeCustomerOtherLimitation).toPromise();
  }

  /**
   * GET RAW MATERIAL GRADES FOR ENQUIRY
   * @param normGradeIds 
   * @returns 
   */
  getRawMaterialGradesForEnquiry(normGradeIds: number[]): Observable<RawMaterialGradesForEnquiry> {
    if (normGradeIds && normGradeIds.length) {
      let _param: string = "";
      for (var x = 0; x < normGradeIds.length; x++) {
        _param += 'normGradesId=' + normGradeIds[x] + ((x < normGradeIds.length - 1) ? "&" : '');
      }
      return this.httpClient.get<RawMaterialGradesForEnquiry>(this.globals.apiUrl + "GetRawMaterialGradesForEnquiry?" + _param);
    } else {
      return this.httpClient.get<RawMaterialGradesForEnquiry>(this.globals.apiUrl + "GetRawMaterialGradesForEnquiry");
    }
  }

  /**
   * GET LIMITATIONS FOR NORM GRADES
   * @param normGradesId 
   * @returns 
   */
  getLimitationsForNormGrades(normGradesId: number[]): Observable<LimitationsForNormGrades> {
    let _param: string = "";
    for (var x = 0; x < normGradesId.length; x++) {
      _param += 'normGradesId=' + normGradesId[x] + ((x < normGradesId.length - 1) ? "&" : '');
    }
    return this.httpClient.get<LimitationsForNormGrades>(this.globals.apiUrl + "GetLimitationsFromNormGrades?" + _param);
  }

  /**
   * GetHeaderParametersValues
   * @returns 
    */
  getHeaderParametersValues(): Observable<HeaderParametersValues> {
    return this.httpClient.get<HeaderParametersValues>(this.globals.apiUrl + "GetHeaderParametersValues");
  }

  /**
   * GetEnquiryByEnquiryNo
   * @returns 
   */
  getEnquiryByEnquiryNo(enquiryNo: string): Observable<EnquiryByEnquiryNo> {
    return this.httpClient.get<EnquiryByEnquiryNo>(this.globals.apiUrl + "GetEnquiryByNo?enquiryNo=" + enquiryNo);
  }

  /**
   * GetItemsByEnquiryNo
   * @returns 
  */
  getItemsByEnquiryNo(enquiryNo: string, includeFinalPricesPerPiece: boolean = false, includeDeliveryDateForSap: boolean = false): Observable<ItemsByEnquiryNo> {
    return this.httpClient.get<ItemsByEnquiryNo>(this.globals.apiUrl + "GetItemsByEnquiryNo?enquiryNo=" + enquiryNo + "&includeFinalPricesPerPiece=" + includeFinalPricesPerPiece + "&includeDeliveryDateForSap=" + includeDeliveryDateForSap);
  }

  /**
   * GET APPLICATION NORMS
   */
  getApplicationNorms(): Observable<any> {
    //ToDO
    return of(null);
  }

  /**
    * GetItemParametersValues
    * @returns 
   */
  getItemParametersValues(): Observable<ItemParametersValues> {
    return this.httpClient.get<ItemParametersValues>(this.globals.apiUrl + "GetItemParametersValues");
  }

  /**
    * GetExtraCostsReasons
    * @returns 
   */
  geExtraCostsReasons(): Observable<ExtraCostsReasons> {
    return this.httpClient.get<ExtraCostsReasons>(this.globals.apiUrl + "GetExtraCostsReasons");
  }

  /**
    * GetPastItrs
    * @returns 
   */
  getPastItrs(): Observable<PastItrs> {
    return this.httpClient.get<PastItrs>(this.globals.apiUrl + "GetPastItrs");
  }

  /**
    *GetItdcrCreationInfo
    * @returns 
   */
  getItdcrCreationInfo(): Observable<ItdcrCreationInfo> {
    return this.httpClient.get<ItdcrCreationInfo>(this.globals.apiUrl + "GetItdcrCreationInfo");
  }

  /**
      *GetExcelTemplateForItdcr
      * @returns 
     */
  getExcelTemplateForItdcr(): Observable<ExcelTemplateForItdcr> {
    return this.httpClient.get<ExcelTemplateForItdcr>(this.globals.apiUrl + "GetExcelTemplateForItdcr");
  }

  /**
    *GetItdcrOffices
    * @returns 
   */
  getIctOffices(): Observable<ItdcrOffices> {
    return this.httpClient.get<ItdcrOffices>(this.globals.apiUrl + "GetItdcrOffices");
  }

  /**
   *GetItdcrs
   * @returns 
  */
  getItdcrs(): Observable<Itdcrs> {
    return this.httpClient.get<Itdcrs>(this.globals.apiUrl + "GetItdcrs");
  }

  /**
   *GetItdcrDetailsVersions
   * @returns 
  */
  getItdcrDetailsVersions(): Observable<ItdcrDetailsVersions> {
    return this.httpClient.get<ItdcrDetailsVersions>(this.globals.apiUrl + "GetItdcrDetailsVersions");
  }

  /**
  *GetItdcrDetailsByVersion
  * @returns 
 */
  getItdcrDetailsByVersion(): Observable<ItdcrDetailsByVersion> {
    return this.httpClient.get<ItdcrDetailsByVersion>(this.globals.apiUrl + "GetItdcrDetailsByVersion");
  }

  /**
  *GetEnquiryClosureStatusesAndLostReasons
  * @returns 
 */
  getEnquiryClosureStatusesAndLostReasons(enquiryNo: string): Observable<EnquiryClosureStatusesAndLostReasons> {
    return this.httpClient.get<EnquiryClosureStatusesAndLostReasons>(this.globals.apiUrl + "GetEnquiryClosureStatusesAndLostReasons?enquiryNo=" + enquiryNo);
  }

  /**
 *GetFileUrlByKey
 * @returns 
*/
  getFileUrlByKey(): Observable<FileUrlByKey> {
    return this.httpClient.get<FileUrlByKey>(this.globals.apiUrl + "GetFileUrlByKey");
  }

  /**
 *GetHistoryByEnquiry
 * @returns 
*/
  getHistoryByEnquiry(enquiryId: number): Observable<HistoryByEnquiry> {
    return this.httpClient.get<HistoryByEnquiry>(this.globals.apiUrl + "GetHistoryByEnquiry?enquiryId=" + enquiryId);
  }

  /**
*GetNpsAndSchedules
* @returns 
*/
  getNpsAndSchedules(): Observable<NpsAndSchedules> {
    return this.httpClient.get<NpsAndSchedules>(this.globals.apiUrl + "GetNpsAndSchedules");
  }

  /**
   * DISCARD EDIT ENQUIRY
   * @param enquiryNo 
   */
  discardEnquiryEdit(enquiryNo: string): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "DiscardEnquiryEdit?enquiryNo=" + enquiryNo, null);
  }

  /**
 * CLOSE EDIT SESSION
 * @param enquiryNo 
 */
  closeEnquiryEditingSession(enquiryNo: string, freezeEnquiry?: FreezeEnquiry): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "CloseEnquiryEditingSession?enquiryNo=" + enquiryNo, { freezeEnquiry });
  }

  /**
   * DUPLICATE ENQUIRY
   * @param enquiryNo 
   * @returns 
   */
  duplicateEnquiry(enquiryNo: string): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "EnquiryDuplicate?sourceEnquiryNo=" + enquiryNo, null);
  }

  /**
   * ENQUIRY CLOSE
   * @param data 
   * @returns 
   */
  enquiryClose(data: CloseEnquiryData): Observable<any> {
    const { enquiryNo, closureReason, ...payload } = data;
    const requestPayload = {
      ...payload,
      closureStatus: closureReason
    };
    return this.httpClient.post<any>(this.globals.apiUrl + "EnquiryClose?enquiryNo=" + enquiryNo, requestPayload);
  }

  /**
   * UPDATE ENQUIRY ITEMS
   * @param items 
   * @returns 
   */
  updateEnquiryItems(items: ItemToUpdate[], enquiryNo: string): Observable<any> {
    // Rimuovo itemNo valorizzati dagli attachments (se ci sono)
    /*     for (var x=0; x < items.length; x++){
          if (items[x].attachments && items[x].attachments!.length > 0){
            for (var k=0; k < items[x].attachments!.length; k++){
              delete items[x].attachments![k]["itemNo"];
            }
          }
        } */

    const normalizedItems: ItemToUpdate[] = items.map((item) => ({
      ...item,
      alloySurcharge: true
    }));

    let _obj: any = {
      "items": normalizedItems
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "UpdateEnquiryItems?enquiryNo=" + enquiryNo, _obj);
  }

  /**
   * UPLOAD ATTACHMENT
   * @param attachment 
   */
  uploadItemAttachment(attachment: AttachmentToUpdate[], itemNo: string, enquiryNo: string): Observable<any> {
    let _obj: any = {
      "attachments": attachment
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "UploadItemAttachment?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, _obj);
  }

  /**
   * DELETE ITEM ATTACHMENT
   * @param attachId 
   * @param itemNo 
   * @param enquiryNo 
   * @returns 
   */
  deleteItemAttachment(attachIds: number[], itemNo: string, enquiryNo: string): Observable<any> {
    let _obj: any = {
      "attachmentsId": attachIds
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "DeleteItemAttachment?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, _obj);
  }

  /**
   * DOWNLOAD ITEMS FILE
   * @param enquiryNo 
   * @returns 
   */
  downloadItemsFile(enquiryNo: string, datasetType: 'EditItems' | 'EditPrices', gridColumns: DownloadGridColumn[]): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "DownloadItemsFile?enquiryNo=" + enquiryNo + '&datasetType=' + datasetType,
      { GridColumns: gridColumns });
  }

  /**
   * UPLOAD ITEMS FILE
   * @param enquiryNo 
   * @param base64 
   * @returns 
   */
  uploadItemsFile(enquiryNo: string, base64: string): Observable<ItemsFromXlsx> {
    let _obj: any = {
      fileContent: base64
    };
    return this.httpClient.post<any>(this.globals.apiUrl + "UploadItemsFile?enquiryNo=" + enquiryNo, _obj);
  }

  /**
 * UPLOAD ITEMS PRICES FILE
 * @param enquiryNo 
 * @param base64 
 * @returns 
 */
  UploadItemsPricesFile(enquiryNo: string, base64: string): Observable<ItemsPricesFromXlsx> {
    let _obj: any = {
      fileContent: base64
    };
    return this.httpClient.post<any>(this.globals.apiUrl + "UploadItemsPricesFile?enquiryNo=" + enquiryNo, _obj);
  }


  /**
   * CHANGE MST OFFER STATUS
   * @param mstOfferStatus 
   * @param enquiryNo 
   * @returns 
   */
  changeMstOfferStatus(mstOfferStatus: string, enquiryNo: string, freezeEnquiry?: FreezeEnquiry): Observable<any> {
    let _obj: any = {
      mstOfferStatus: mstOfferStatus,
      freezeEnquiry
    };
    return this.httpClient.post<any>(this.globals.apiUrl + "ChangeMstOfferStatus?enquiryNo=" + enquiryNo, _obj);
  }

  calculateItemWeight(calculateItemWeightParameters: CalculateItemWeightParamters): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "CalculateItemWeight", calculateItemWeightParameters);
  }

  /**
   * GET USERS
   * @returns 
   */
  getUsers(userName: string | null): Observable<Users> {
    let _queryParam: string = userName == null ? '' : '?username=' + userName;
    return this.httpClient.get<Users>(this.globals.apiUrl + "GetUsers" + _queryParam);
  }

  /**
   * GET GROUPS
   * @returns 
   */
  getGroups(groupId: number | null): Observable<Groups> {
    let _param: string = groupId != null ? '?groupid=' + groupId : ''
    return this.httpClient.get<Groups>(this.globals.apiUrl + "GetAuthorizationsGroups" + _param);
  }

  /**
   * GET AUTH INFO
   * @returns 
   */
  getAuthorizationsInfo(): Observable<AuthorizationInfo> {
    return this.httpClient.get<AuthorizationInfo>(this.globals.apiUrl + "GetAuthorizationsInfo");
  }

  /**
   * DELETE USER
   * @param username 
   * @returns 
   */
  deleteUser(username: string): Observable<any> {
    return this.httpClient.patch<any>(this.globals.apiUrl + "DeleteUser?username=" + username, null);
  }

  /**
   * GET ACTIVE DIRECTORY USERS
   * @param username 
   * @returns 
   */
  searchInAd(username: string): Observable<AdUsers> {
    return this.httpClient.get<AdUsers>(this.globals.apiUrl + "GetActiveDirectoryUsers?searchString=" + username);
  }

  /**
   * CREATE USER
   * @param userToSave 
   * @returns 
   */
  createUser(userToSave: UserToSave): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "CreateUser", userToSave);
  }

  /**
   * UPDATE USER
   * @param userToSave 
   * @returns 
   */
  updateUser(userToSave: UserToSave, userName: string): Observable<any> {
    return this.httpClient.patch<any>(this.globals.apiUrl + "UpdateUser?username=" + userName, userToSave);
  }

  /**
   * DELETE GROUP
   * @param groupName 
   * @returns 
   */
  deleteGroup(groupId: number): Observable<any> {
    return this.httpClient.delete<any>(this.globals.apiUrl + "DeleteAuthorizationsGroup?groupId=" + groupId);
  }

  /**
   * CREATE GROUP
   * @param groupToSave 
   * @returns 
   */
  createGroup(groupToSave: GroupToSave): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "CreateAuthorizationsGroup", groupToSave);
  }

  /**
   * UPDATE GROUP
   * @param groupToSave 
   * @returns 
   */
  updateGroup(groupToSave: GroupToSave, groupId: number): Observable<any> {
    return this.httpClient.put<any>(this.globals.apiUrl + "UpdateAuthorizationsGroup?groupid=" + groupId, groupToSave);
  }

  /*** ODATA FILTERS */

  /**
   * GET ENQUIRY BOOK FILTERS
   * @returns 
   */
  getEnquiryBookFiltersValues(filterScope?: string): Observable<any[]> {
    let params = new HttpParams();
    if (filterScope) {
      params = params.set('filterScope', filterScope);
    }

    return this.httpClient.get<any[]>(this.globals.apiUrl + "GetEnquiryBookFiltersValues", { params });
  }

  /**
   * GET LOGS FILTERS
   * @returns 
   */
  getLogsFiltersValues(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.globals.apiUrl + "GetLogsFiltersValues");
  }

  /**
   * GET HISTORY FILTERS
   * @returns 
   */
  getHistoryFiltersValues(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.globals.apiUrl + "GetHistoryFiltersValues");
  }

  /**
 * GET ITDCR FILTERS
 * @returns 
 */
  getCurrentItdcrsFiltersValues(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.globals.apiUrl + "GetCurrentItdcrsFiltersValues");
  }

  getHistoryItdcrsFiltersValues(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.globals.apiUrl + "GetHistoryItdcrsFiltersValues");
  }

  /**
   * SetItemFeasibleByExperience
   * @param enquiryNo 
   * @param itemNo 
   * @param comments 
   * @returns 
   */
  setItemFeasibleByExperience(enquiryNo: string, itemNo: string, comments: string): Observable<any> {
    let _obj: any = {
      "comments": comments
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "SetItemFeasibleByExperience?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, _obj);
  }

  /**
   * GetItemFeasibilityDetails
   * @param enquiryNo 
   * @param itemNo 
   * @returns 
   */
  getItemFeasibilityDetails(enquiryNo: string, itemNo: string): Observable<FeasibilityDetail> {
    return this.httpClient.get<FeasibilityDetail>(this.globals.apiUrl + "GetItemFeasibilityDetails?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo);
  }

  /**
  * GetQuotationDataAndConfiguration
  * @param enquiryNo 
  * @returns 
  */
  getQuotationDataAndConfiguration(enquiryNo: string): Observable<QuotationDataAndConfiguration> {
    return this.httpClient.get<QuotationDataAndConfiguration>(this.globals.apiUrl + "GetQuotationDataAndConfiguration?enquiryNo=" + enquiryNo);
  }

  /**
  * SaveQuotationConfigurationAndPdf
  * @param enquiryNo 
  * @returns 
  */
  saveQuotationConfigurationAndPdf(enquiryNo: string, quotationConfigurationAndPdf: QuotationConfigurationAndPdf): Observable<any> {
    return this.httpClient.put<any>(this.globals.apiUrl + "SaveQuotationConfigurationAndPdf?enquiryNo=" + enquiryNo, quotationConfigurationAndPdf);
  }



  /**
  * GetQuotationPdf
  * @param enquiryNo 
  * @returns
  */
  getQuotationPdf(enquiryNo: string): Observable<any> {
    return this.httpClient.get<any>(this.globals.apiUrl + "GetQuotationPdf?enquiryNo=" + enquiryNo);
  }

  /**
  * EnquiryReOpen
  * @param enquiryNo 
  * @returns 
  */
  enquiryReOpen(enquiryNo: string, customerRequestDate: number | null = null, keepItdcrResults?: boolean): Observable<{hasPriceOrMarginChanges: boolean, newRevisionEnquiryNo: string}> {
    const payload: any = { customerRequestDate: customerRequestDate };
    if (keepItdcrResults) {
      payload.keepItdcrResults = true;
    }
    return this.httpClient.post<{hasPriceOrMarginChanges: boolean, newRevisionEnquiryNo: string}>(this.globals.apiUrl + "EnquiryReOpen?enquiryNo=" + enquiryNo, payload);
  }

  /* COSTING TOOL SECTIONS */

  /**
   * GET COSTIONG TOOL FILTER VALUES
   * @returns 
   */
  getCostingToolFiltersValues(): Observable<CostingToolFilterValue> {
    return this.httpClient.get<CostingToolFilterValue>(this.globals.apiUrl + "GetCostingToolFiltersValues");
  }

  getUnitSystemAndCurrencyByUser(): Observable<{ unitSystem?: string, currency?: string }> {
    return this.httpClient.get<{ unitSystem?: string, currency?: string }>(this.globals.apiUrl + "GetUnitSystemAndCurrencyByUser");
  }

  /**
   * GET COSTING TOOL FILTER VALUES BY ITEM 
   * @param enquiryNo 
   * @param itemNo 
   * @returns 
   */
  getCostingToolFiltersValuesByItem(enquiryNo: string, itemNo: string, useNearestMatch: boolean = false): Observable<CostingToolFilterValueByItem> {
    return this.httpClient.get<CostingToolFilterValueByItem>(this.globals.apiUrl + "GetCostingToolFiltersValuesByItem?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo + "&useNearestMatch=" + useNearestMatch);
  }

  /**
   * GET COSTING TOOLS RECORDS
   * @param rawMaterialGrade 
   * @param asIncluded 
   * @param od 
   * @param wt 
   * @param insideDiameter 
   * @param process 
   * @param ut 
   * @param hydro 
   * @param lengthType 
   * @param htHot 
   * @param htCold 
   * @param htAdd 
   * @returns 
   */
  getCostingToolRecords(rawMaterialGrade: string, asIncluded: boolean, od: number, wt: number, insideDiameter: number, process: string, ut: boolean, hydro: boolean, lengthType: string,
    htHot: boolean, htCold: boolean, htAdd: boolean, selectedVersionId: number, lengthMin: number, lengthMax: number, uBent: boolean, plant: string, endsCondition: string, testCondition: string, sql: string,
    unitSystem: string, currency: string): Observable<CostingToolRecordsResponse> {
    let _query: string = "";
    _query = "?rawMaterialGrade=" + rawMaterialGrade + "&asIncluded=" + asIncluded;
    if (od != null) _query += "&od=" + od;
    if (wt != null) _query += "&wt=" + wt;
    if (insideDiameter != null) _query += "&insideDiameter=" + insideDiameter;
    if (process != null) _query += "&process=" + process;
    if (ut != null) _query += "&ut=" + ut;
    if (hydro != null) _query += "&hydro=" + hydro;
    if (lengthType != null) _query += "&lengthType=" + lengthType;
    if (htHot != null) _query += "&htHot=" + htHot;
    if (htCold != null) _query += "&htCold=" + htCold;
    if (htAdd != null) _query += "&htAdd=" + htAdd;
    if (selectedVersionId != null) _query += "&versionId=" + selectedVersionId;
    if (lengthMin != null) _query += "&lengthMin=" + lengthMin;
    if (lengthMax != null) _query += "&lengthMax=" + lengthMax;
    if (uBent != null) _query += "&uBent=" + uBent;
    if (plant != null) _query += "&plant=" + plant;
    if (endsCondition != null) _query += "&endsCondition=" + endsCondition;
    if (testCondition != null) _query += "&testCondition=" + testCondition;
    if (sql != null) _query += "&sql=" + sql;
    if (unitSystem != null && unitSystem != '') _query += "&unitSystem=" + encodeURIComponent(unitSystem);
    if (currency != null && currency != '') _query += "&currency=" + encodeURIComponent(currency);

    console.log("GET COSTING TOOL RECORDS query: " + _query);
    return this.httpClient.get<CostingToolRecordsResponse>(this.globals.apiUrl + "GetCostingToolRecords" + _query);
  }

  /**
   * GET COSTING TOOL RECORDS BY ID
   * @param recordId 
   * @param versionId 
   * @returns 
   */
  getCostingToolRecordsById(recordId: number, versionId: number, unitSystem?: string | null, currency?: string | null): Observable<CostingToolRecordsResponse> {
    let _query: string = "?versionId=" + versionId + "&recordId=" + recordId;
    if (unitSystem != null && unitSystem != '') _query += "&unitSystem=" + encodeURIComponent(unitSystem);
    if (currency != null && currency != '') _query += "&currency=" + encodeURIComponent(currency);

    return this.httpClient.get<CostingToolRecordsResponse>(this.globals.apiUrl + "GetCostingToolRecordsById" + _query);
  }

  /**
   * RECOMPUTE COST
   * @param enquiryNo 
   * @param itemNo 
   * @returns 
   */
  recomputeCost(enquiryNo: string, itemNo: string): Observable<any> {
    return this.httpClient.post<any>(this.globals.apiUrl + "RecomputeCost?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, null);
  }

  /**
   * SET ITEM COSTING TOOL
   * @param enquiryNo 
   * @param itemNo 
   * @param costingToolId 
   */
  setItemCostByCostingTool(enquiryNo: string, itemNo: string, costingToolId: number): Observable<any> {
    let _obj: any = {
      costingToolId: costingToolId
    };
    return this.httpClient.post<any>(this.globals.apiUrl + "SetItemCostByCostingTool?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, _obj);
  }

  /**
   * GET EXTRA COSTS PARAMETERS VALUES
   * @returns 
   */
  getExtraCostsParametersValues(currency?: string | null) {
    let params = new HttpParams();

    if (currency) {
      params = params.set("currency", currency);
    }

    return this.httpClient.get<ExtraCostParametersValues>(this.globals.apiUrl + "GetExtraCostsParametersValues", { params });
  }

  /**
 * GET ITEM EXTRA COSTS
 * @param unitSystem 
 * @returns 
 */
  getItemExtraCosts(enquiryNo: string, itemNo: string) {
    return this.httpClient.get<ItemExtraCosts>(this.globals.apiUrl + "GetItemExtraCosts?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo);
  }



  /**
* SET ORDER EXTRA COSTS
* @param unitSystem 
* @returns 
*/
  setOrderExtraCost(enquiryNo: string, orderExtraCost: OrderExtraCost) {
    return this.httpClient.patch(this.globals.apiUrl + "SetOrderExtraCost?enquiryNo=" + enquiryNo, orderExtraCost);
  }

  /**
* SET ITEM EXTRA COSTS
* @param unitSystem 
* @returns 
*/
  setItemExtraCosts(enquiryNo: string, itemNo: string, itemExtraCosts: ItemExtraCosts) {
    // TODO: does not make sense to send the whole extra costs object, the itemextracost names should not be sent back to the server
    return this.httpClient.patch(this.globals.apiUrl + "SetItemExtraCosts?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, { itemExtraCosts });
  }

  /**
   * UPLOAD ATTACHMENT FOR EDIT ENQUIRY
   * @param enquiryNo 
   * @param attachment
   * @returns 
   */
  uploadEnquiryAttachment(enquiryNo: string, attachments: AttachmentToUpdate[]): Observable<any> {
    for (var x = 0; x < attachments.length; x++) {
      delete attachments[x].attachmentsId;
    }

    let _obj: any = {
      enquiryAttachments: attachments
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "UploadEnquiryAttachment?enquiryNo=" + enquiryNo, _obj);
  }

  /**
   * DELETE ENQUIRY ATTACHMENT
   * @param enquiryNo 
   * @param attachmentId 
   * @returns 
   */
  deleteEnquiryAttachment(enquiryNo: string, attachmentId: number[]): Observable<any> {
    let _obj: any = {
      enquiryAttachmentsId: attachmentId
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "DeleteEnquiryAttachment?enquiryNo=" + enquiryNo, _obj);
  }

  /**
   * GET ENQUIRY ATTACHMENT
   * @param enquiryNo 
   * @returns 
   */
  getEnquiryAttachments(enquiryNo: string): Observable<any> {
    return this.httpClient.get<any>(this.globals.apiUrl + "GetEnquiryAttachments?enquiryNo=" + enquiryNo);
  }

  /**
   * UPDATE ITEMS PRICE
   * @param enquiryNo 
   * @param itemPrice 
   * @returns 
   */
  UpdateItemsPriceAndDelivery(enquiryNo: string, itemPrice: UpdateItemsPriceAndDelivery) {
    return this.httpClient.put(this.globals.apiUrl + "UpdateItemsPriceAndDelivery?enquiryNo=" + enquiryNo, itemPrice);
  }


  calculateMarginsAndPrices(enquiryNo: string, itemNo: string, payload: CalculateMarginsAndPricesPayload): Observable<CalculateMarginsAndPricesResponse> {
    return this.httpClient.post<any>(this.globals.apiUrl + "CalculateMarginsAndPrices?enquiryNo=" + enquiryNo + "&itemNo=" + itemNo, payload);
  }

  /**
   * GET MASTERDATA VERSIONS
   * @returns 
   */
  getMasterDataVersions(masterDataType: string): Observable<MasterDataVersion> {
    return this.httpClient.get<MasterDataVersion>(this.globals.apiUrl + "GetMasterDataVersions?masterDataType=" + masterDataType);
  }

  /**
   * 
   * @param base64Content 
   * @returns 
   */
  uploadMasterData(fileType: string, base64Content: string, millId: number): Observable<UploadMasterDataResponse> {
    return this.httpClient.post<UploadMasterDataResponse>(this.globals.apiUrl + "UploadMasterData", {
      fileType: fileType,
      fileContent: base64Content,
      millId: millId
    });
  }

  downloadMasterDataTemplate(fileType: string, millId: number, includeData: boolean = false): Observable<DownloadMasterDataResponse> {
    return this.httpClient.post<DownloadMasterDataResponse>(this.globals.apiUrl + "DownloadMasterDataTemplate", {
      fileType: fileType,
      millId: millId,
      includeLastUploadedData: includeData
    });
  }


  /**
   * Get Technical Description Templates
   * @returns 
   */
  getTechnicalDescriptionTemplates() {
    return this.httpClient.get<TechnicalDescriptionTemplates>(this.globals.apiUrl + "GetTechnicalDescriptionTemplates");
  }

  /**
   * 
   * @param templateId 
   * @returns 
   */
  deleteTechnicalDescriptionTemplate(templateId: number) {
    return this.httpClient.delete(this.globals.apiUrl + "DeleteTechnicalDescriptionTemplate?templateId=" + templateId);
  }

  createTechnicalDescriptionTemplate(newTemplate: any) {
    return this.httpClient.post(this.globals.apiUrl + "CreateTechnicalDescriptionTemplate", newTemplate);
  }


  /**
   * 
   * @param enquiryNo 
   * @param content 
   * @returns 
   */
  parseItemsFromFile(enquiryNo: string, payload: ItemsFromAIFilePayload) {
    return this.httpClient.post<ItemsFromAI>(this.globals.apiUrl + "ParseItemsFromFile?enquiryNo=" + enquiryNo, payload);
  }

  /**
 * 
 * @param enquiryNo 
 * @param content 
 * @returns 
 */
  countItemsToBeParsedFromFile(enquiryNo: string, payload: ItemsFromAIFilePayload) {
    return this.httpClient.post<ItemsCount>(this.globals.apiUrl + "CountItemsToBeParsedFromFile?enquiryNo=" + enquiryNo, payload);
  }

  /**
   * 
   * @returns 
   */
  getItemParametersLengthValues(): Observable<ItemParametersLengthValues> {
    return this.httpClient.get<ItemParametersLengthValues>(this.globals.apiUrl + "GetDefaultLengths");
  }


  getImportFileTypes(): Observable<ImportFileTypesResponse> {
    return this.httpClient.get<ImportFileTypesResponse>(this.globals.apiUrl + "GetImportFileTypes");
  }

  getSimiliarEnquiriesByHeader(projectName: string): Observable<SimiliarEnquiries> {
    return this.httpClient.get<SimiliarEnquiries>(this.globals.apiUrl + "GetSimilarEnquiriesByHeader?projectName=" + projectName);
  }

  getSimiliarEnquiriesByEnquiryNo(enquiryNo: string): Observable<SimiliarEnquiries> {
    return this.httpClient.get<SimiliarEnquiries>(this.globals.apiUrl + "GetSimilarEnquiriesByItems?enquiryNo=" + enquiryNo);
  }

  /**
   * 
   * @returns Materials List
   */
  getMaterials(): Observable<Materials> {
    return this.httpClient.get<Materials>(this.globals.apiUrl + "GetMaterials");
  }

  getItemAttributesByMaterialCode(materialCode: string, unitSystem: string): Observable<ItemAttributesByMaterialCode> {
    return this.httpClient.get<ItemAttributesByMaterialCode>(this.globals.apiUrl + `GetItemAttributesByMaterialCode?materialCode=${materialCode}&unitSystem=${unitSystem}`);
  }

  submitFrozenEnquiryDecision(enquiryNo: string, decision: {
    decision: 'Accept' | 'Refuse',
    notes?: string
  }) {
    return this.httpClient.post(this.globals.apiUrl + `SubmitFrozenEnquiryDecision?enquiryNo=${enquiryNo}`, decision);
  }

  checkEnquiryTotalMargin(enquiryNo: string, requestedAction: 'CloseEnquiryEditingSession' | 'ChangeMstOfferStatus'): Observable<CheckEnquiryTotalMargin> {
    return this.httpClient.get<CheckEnquiryTotalMargin>(this.globals.apiUrl + `CheckEnquiryTotalMargin?enquiryNo=${enquiryNo}&requestedAction=${requestedAction}`);
  }

  getEnquiryTotalPriceAndMargin(
    enquiryNo: string,
    options?: {
      usePayloadItems?: boolean;
      payload?: EnquiryTotalPriceAndMarginPayload;
    }
  ): Observable<EnquiryTotalPriceAndMargin | null> {
    const usePayloadItems = !!options?.usePayloadItems;
    const query = `${this.globals.apiUrl}GetEnquiryTotalPriceAndMargin?enquiryNo=${enquiryNo}${usePayloadItems ? '&usePayloadItems=true' : '&usePayloadItems=false'}`;

    return this.httpClient.post<EnquiryTotalPriceAndMargin | null>(
      query,
      usePayloadItems ? (options?.payload ?? { items: [] }) : {}
    );
  }

  getItdcrOfficesByParameters(
    itdcrMillId: number,
    technical: boolean,
    cost: boolean,
    delivery: boolean,
    enquiryNo: string,
    itemsNo: string[]
  ): Observable<GetItdcrOffices> {

    let url =
      `${this.globals.apiUrl}GetItdcrOffices/ByParameters` +
      `?itdcrMillId=${itdcrMillId}` +
      `&technical=${technical}` +
      `&cost=${cost}` +
      `&delivery=${delivery}` +
      `&enquiryNo=${encodeURIComponent(enquiryNo)}`;

    itemsNo.forEach(item => {
      url += `&itemsNo=${encodeURIComponent(item)}`;
    });

    return this.httpClient.get<GetItdcrOffices>(url);
  }


  getItdcrOfficesByItdcr(itdcrNo: string): Observable<GetItdcrOffices> {
    return this.httpClient.get<GetItdcrOffices>(this.globals.apiUrl + `GetItdcrOffices/ByItdcr?ItdcrNo=${itdcrNo}`);
  }

  getAttachmentsForItdcrByEnquiryNo(
    enquiryNo: string,
    itdcrMillId: number,
    itemsNo: string[]
  ): Observable<ItcdrAttachments> {

    let url =
      `${this.globals.apiUrl}GetAttachmentsForItdcr/ByEnquiry` +
      `?enquiryNo=${encodeURIComponent(enquiryNo)}` +
      `&itdcrMillId=${itdcrMillId}`;

    itemsNo.forEach(item => {
      url += `&itemsNo=${encodeURIComponent(item)}`;
    });

    return this.httpClient.get<ItcdrAttachments>(url);
  }


  createItdcr(request: CreateItdcrRequest): Observable<CreateItdcrResponse> {
    return this.httpClient.post<CreateItdcrResponse>(this.globals.apiUrl + `CreateItdcr?`, request);
  }

  closeItdcr(itdcrNo: string): Observable<any> {
    return this.httpClient.post(this.globals.apiUrl + "CloseItdcr?itdcrNo=" + itdcrNo, null);
  }

  cancelItdcr(itdcrNo: string): Observable<any> {
    return this.httpClient.post(this.globals.apiUrl + "CancelItdcr?itdcrNo=" + itdcrNo, null);
  }

  rejectItdcr(itdcrNo: string, notes: string): Observable<any> {
    return this.httpClient.post(this.globals.apiUrl + "RejectItdcr?itdcrNo=" + itdcrNo, {
      notes: notes
    });
  }

  sendItdcr(itdcrNo: string, payload: SendItdcrRequest): Observable<any> {
    return this.httpClient.post(this.globals.apiUrl + "SendItdcr?itdcrNo=" + itdcrNo, payload);
  }

  getAttachmentsForItdcrByItdcr(itdcrNo: string) {
    return this.httpClient.get<ItcdrAttachments>(this.globals.apiUrl + `GetAttachmentsForItdcr/ByItdcr?itdcrNo=${itdcrNo}`);
  }

  getItdcrVisualOverwievInfo(itdcrNo: string) {
    return this.httpClient.get<ItdcrVisualOverwiev>(this.globals.apiUrl + `GetItdcrVisualOverwievInfo?itdcrNo=${itdcrNo}`);
  }

  setItdcrTemporaryNotes(itdcrNo: string, notes: string) {
    const payload = {
      temporaryNotes: notes
    };

    return this.httpClient.patch(this.globals.apiUrl + `SetItdcrTemporaryNotes?itdcrNo=${itdcrNo}`, payload);
  }

  uploadItdcrAttachment(itdcrNo: string, attachments: AttachmentToUpdate[]): Observable<any> {
    let _obj: any = {
      itdcrAttachments: attachments
    }
    return this.httpClient.post<any>(this.globals.apiUrl + "UploadItdcrAttachments?itdcrNo=" + itdcrNo, _obj);
  }

  deleteItdcrAttachment(itdcrNo: string, attachmentIds: number[]): Observable<any> {
    const payload: any = {
      itdcrAttachmentsId: attachmentIds
    };
    return this.httpClient.post<any>(this.globals.apiUrl + "DeleteItdcrAttachment?itdcrNo=" + itdcrNo, payload);
  }

  getEnquiryCustomerSpecialRequirements(enquiryNo: string): Observable<{ customerSpecialRequirements: CustomerSpecialRequirement[]; }> {
    return this.httpClient.get<{ customerSpecialRequirements: CustomerSpecialRequirement[] }>(this.globals.apiUrl + "GetEnquiryCustomerSpecialRequirements?enquiryNo=" + enquiryNo);
  }

  getItdcrMills(): Observable<GetItdcrMillsResponse> {
    return this.httpClient.get<GetItdcrMillsResponse>(this.globals.apiUrl + "GetItdcrMills");
  }

  setItemCost(enquiryNo: string, itemNo: string, cost: number, asValue: number | null): Observable<any> {
    const payload = {
      cost: cost,
      asValue: asValue
    };
    return this.httpClient.patch(this.globals.apiUrl + `SetItemCost?enquiryNo=${enquiryNo}&itemNo=${itemNo}`, payload);
  }

  submitItdcrFeasibilityDecision(enquiryNo: string, itemNo: string, decision: 'Confirm' | 'Reject') {
    const payload = {
      decision: decision
    };
    return this.httpClient.post(this.globals.apiUrl + `SubmitItdcrFeasibilityDecision?enquiryNo=${enquiryNo}&itemNo=${itemNo}`, payload);
  }

  updateItemDeliveryDates(enquiryNo: string, itemNo: string, preparedCollection: { deliveryQuantityUom: string; deliveryNumberOfWeeks?: number; deliveryNumberOfWeeksWithExtraLeadTime?: number; deliveryQuantity?: number; deliveryWeekOfYear?: string; }[]) {
    const payload = {
      deliveryDatesCollection: preparedCollection
    };

    return this.httpClient.put(this.globals.apiUrl + `UpdateItemDeliveryDates?enquiryNo=${enquiryNo}&itemNo=${itemNo}`, payload);
  }

  hasEnquiryItdcrResults(enquiryNo: string): Observable<{ hasEnquiryItdcrResults: boolean; }> {
    return this.httpClient.get<{ hasEnquiryItdcrResults: boolean; }>(this.globals.apiUrl + `HasEnquiryItdcrResults?enquiryNo=${enquiryNo}`);
  }

  getInProgressItdcrNumberByItem(enquiryNo: string, itemNo: string): Observable<{ itdcrNo: string; }> {
    return this.httpClient.get<{ itdcrNo: string; }>(this.globals.apiUrl + `GetInProgressItdcrNumberByItem?enquiryNo=${enquiryNo}&itemNo=${itemNo}`);
  }

  getItdcrNumberByItemAndCategory(enquiryNo: string, itemNo: string, category: 'F' | 'P' | 'D'): Observable<{ itdcrNo: string | null; }> {
    return this.httpClient.get<{ itdcrNo: string | null; }>(
      this.globals.apiUrl
      + `GetItdcrNumberByItemAndCategory?enquiryNo=${encodeURIComponent(enquiryNo)}&itemNo=${encodeURIComponent(itemNo)}&category=${category}`
    );
  }

  getInfoUrl(): Observable<{ infoUrl: string; }> {
    return this.httpClient.get<{ infoUrl: string; }>(this.globals.apiUrl + "GetInfoUrl");
  }
}

